<template>
    <div id="staffs">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <Filters></Filters>

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="staff in staffs"
                    :key="staff.identity"
                    :object="staff"
                    :title="staff.name"
                    :title_link="{name: 'edit_staff', params: {identity: staff.identity}}"
                    :sub_title="data_card_sub_title(staff)"
                    :color="data_card_color(staff)"
                    :is_show_column="true"
                    :keys="['username','phone','role','theme_name','station']"
                    :i_18n_key="'staffs'"
                >
                    <span slot="role">
                        <router-link
                            v-if="$store.state.provider.current_staff.theme_name == 'manager'"
                            :data-tooltip="$t('ui.general.edit') +' '+ $t('models.roles')"
                            :to="{name: 'edit_role', params: {identity: staff.role_identity}}"
                        >
                            {{ role_name(staff) }}
                        </router-link>
                        <span v-else>
                            {{ role_name(staff) }}
                        </span>
                    </span>
                    <span slot="theme_name">
                        {{ $t('ui.theme_names.' + staff.theme_name) }}
                    </span>
                    <span slot="station">
                        {{ station_name(staff) }}
                    </span>
                    <div slot="buttons">
                        <router-link :to="{name: 'appraisals', params: { staff_identity: staff.identity }}" class="ui basic blue button">
                            {{ $t('ui.pages.staffs.appraisals') }}
                        </router-link>
                        <button class="ui basic button" @click="toggle_is_banned(staff)" :class="{ positive: staff.is_banned, negative: !staff.is_banned }">
                            <span v-if="staff.is_banned">
                                <!-- 復權 -->
                                {{ $t('ui.pages.staffs.unbanned') }}
                            </span>
                            <span v-else>
                                <!-- 停權 -->
                                {{ $t('ui.pages.staffs.banned') }}
                            </span>
                        </button>
                        <a @click.prevent="delete_staff(staff)" class="ui basic red button">
                            {{ $t('ui.general.delete') }}
                        </a>
                    </div>
                </DataCard>

                <div class="ui center aligned red segment" v-if="staffs.length <= 0">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui celled table">
                <thead class="center aligned">
                    <tr>
                        <th>{{ $t('models.attributes.staffs.username') }}</th>
                        <th>{{ $t('models.attributes.staffs.name') }}</th>
                        <th>{{ $t('models.attributes.staffs.phone') }}</th>
                        <th>{{ $t('models.attributes.staffs.role') }}</th>
                        <th>{{ $t('models.attributes.staffs.theme_name') }}</th>
                        <th>{{ $t('models.attributes.staffs.station') }}</th>
                        <th>{{ $t('ui.pages.staffs.banned') }}</th>
                        <th>{{ $t('ui.general.operate') }}</th>
                    </tr>
                </thead>
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="6">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else class="center aligned">
                    <Staff v-for="staff in staffs" :key="staff.identity" :staff="staff">
                    </Staff>
                    <tr v-if="staffs.length <= 0" class="center aligned">
                        <td colspan="8" >
                            <h5>{{ $t('ui.general.no_data') }}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div
                is="Paginator"
                :total_pages="Number(pagination.total_pages)"
                :current_page="Number(pagination.current_page)"
                :disabled="is_loading"
                >
            </div>
        </div>
    </div>
</template>

<script>
import Staff from "./index/staff.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
import DataCard from '@toolbox/data_card/main.vue'
import Filters from "./filter/main.vue"

export default {
    name: "StaffsIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.staffs_module
        },
        staffs() {
            return this.current_store.staffs
        },
        roles() {
            return this.current_store.roles
        },
        pagination() {
            return this.current_store.pagination
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
    },
    methods: {
        async init(is_first = true) {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_loading = true
                    this.errors = []
                    resolve()
                })
                await this.$store.dispatch('provider/staffs_module/handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch('provider/staffs_module/handle_quick_filter_key')
                }
                await this.$store.dispatch('provider/staffs_module/fetch_staffs')
                await new Promise(resolve => {
                    this.$noty.information(
                        this.$t("ui.page_titles.staffs") + ' ' +
                        this.$t('ui.general.initialize_complete')
                    , 300)
                    resolve()
                })
            } catch (e) {
                console.log("非預期的錯誤: ", e)
                this.errors.push(e)
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name',{
                        name: this.$t('models.staffs'),
                        reason: e
                    })
                )
            } finally {
                this.is_initialized = true
                this.is_loading = false
            }
        },
        staffs_filter() {
            console.log('staffs_filter')
            try {
                this.$router.push({
                    name: this.$router.name,
                    query: this.$store.getters['provider/staffs_module/filter_to_query'],
                })
            } catch (e) {
                console.log(e)
            }
        },
        init_filter_columns() {
            this.$store.commit('provider/staffs_module/init_filter_columns')
            $("#staffs .ui.dropdown").dropdown('clear')
        },
        toggle_filter() {
            this.$store.commit('provider/staffs_module/toggle_filter')
        },
        data_card_sub_title(staff) {
            return (staff.is_banned)
                ? `<i class="remove icon"></i> ${this.$t('ui.pages.staffs.banned')}`
                : `<i class="check icon"></i> ${this.$t('ui.pages.staffs.normal')}`
        },
        data_card_color(staff) {
            return (staff.is_banned) ? 'red' : 'green'
        },
        role_name(staff) {
            var result = _.find(this.$store.state.provider.staffs_module.roles, role => {
                return role.identity == staff.role_identity
            })
            return (result) ? result.name : "-"
        },
        station_name(staff) {
            var result = _.find(this.$store.state.provider.stations, {
                'identity': staff.station_identity
            })
            return (result) ? result.name : "-"
        },
        delete_staff(staff) {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                this.is_loading = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_staff_delete).parse({
                    "identity": staff.identity,
                })

                axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.$noty.success(
                                this.$t('ui.notifications.success.delete__name', {
                                    name: staff.username
                                })
                            )
                            this.init()
                        } else {
                            this.$noty.error(
                                this.$t('ui.notifications.error.delete__name', {
                                    name: staff.username
                                })
                            )
                        }
                    })
                    .catch(error => {
                        console.log(error.response)
                        // this.$noty.error('刪除staff失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.staff.username
                            })
                        )
                    })
                    .finally(() => {
                        this.is_loading = false
                    })
            }
        },
        toggle_is_banned(staff) {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_staff_update).parse({
                "identity": staff.identity,
            })

            axios.post(url, {is_banned: !staff.is_banned}, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        staff.is_banned = response.data.staff.is_banned
                        // this.$noty.success('更新員工成功')
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.staffs')
                            })
                        )
                        this.$forceUpdate()
                    } else {
                        // this.$noty.error('更新員工失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.update__name', {
                                name: this.$t('models.staffs')
                            })
                        )
                    }
                })
                .catch(error => {
                    console.log(error.response)
                })
        }
    },
    components: {
        Staff,
        Paginator,
        ErrorMessages,
        DataCard,
        Filters
    }
}
</script>

<style scoped lang="scss">
    #staffs {
    }
    .th_dropdown {
        & {
            position: relative;
        }
        span.clear_dropdown {
            position: absolute;
            color: #4c4c4c;
            right: -9px;
            top: -9px;
        }
    }
</style>
